import React from 'react';
import { useParams } from 'react-router-dom';
import PageTabs from '../../../components/PageTabs';
import {
  GearSix as SettingsIcon,
  Buildings as Building2,
  Pulse as Activity,
} from '@phosphor-icons/react';

const SettingsTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();

  const tabs = [
    { key: 'general', label: 'General', icon: SettingsIcon, path: `/${slug}/owner/settings` },
    { key: 'branches', label: 'Branches', icon: Building2, path: `/${slug}/owner/settings/branches` },
    { key: 'activity', label: 'Activity Log', icon: Activity, path: `/${slug}/owner/settings/activity` },
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default SettingsTab;
